import { setSentryBreadcrumbsInfo as setSentryBreadcrumbs } from './setSentryBreadcrumbs';

const polyfills = [];

if (typeof Set === 'undefined' || typeof Set.prototype.keys !== 'function') {
  setSentryBreadcrumbs('polyfill-set');
  polyfills.push(import(/* webpackChunkName: "polyfill-set" */ './set'));
}

if (!String.prototype.startsWith) {
  setSentryBreadcrumbs('polyfill-startsWith');
  polyfills.push(
    import(/* webpackChunkName: "polyfill-startsWith" */ './startsWith')
  );
}

if (!window.requestAnimationFrame) {
  setSentryBreadcrumbs('polyfill-requestAnimationFrame');
  polyfills.push(
    import(
      /* webpackChunkName: "polyfill-requestAnimationFrame" */ './requestAnimationFrame'
    )
  );
}

export default polyfills;
